// WorkspaceCallAction — the call panel's labelled capsule (Accept, Decline,
// Keep, End call). A filled status plate (`theme: 'success' | 'error' |
// 'layer'` at the call site) on the house Button capsule; its interaction
// states live HERE, once (Rule 65): a filled plate takes a brightness lift on
// hover (DESIGN_LANGUAGE §4.3 — a `hover` wash does not read on an opaque
// fill, and opacity would halve the contrast), sinks on press, and dims only
// while disabled (an action in flight).
//
// A glyph-led capsule puts its label in a `Label` child AFTER the icon: the
// framework emits a `text` prop's node BEFORE the Icon child (measured live:
// "Accept" then the glyph), and the house order is glyph first.
export const WorkspaceCallAction = {
  extends: 'Button',
  cursor: 'pointer',
  gap: 'Y',
  // A LABELLED capsule: every call site gives it a label (a `text`, or a
  // `Label` child after the glyph). Declaring the label's line behaviour here
  // also tells the icon-button census (shared iconButtonSquare.test.js) that
  // this base is a capsule, not an icon-only square.
  whiteSpace: 'nowrap',
  transitionProperty: 'filter, transform',
  transition: 'A defaultBezier',
  ':hover': { filter: 'brightness(1.08)' },
  ':active': { transform: 'scale(0.96)' },
  ':disabled': { cursor: 'default', filter: 'saturate(0.6)' },
  Icon: { boxSize: 'iconSm' }
}
